module.exports = __webpack_public_path__ + "img/about_logo.6068159.png";